<template>
    <div v-if="item" class="">
        <div class="row g-4">
            <div class="col-12">
                <label class="small text-muted">Account Name:</label>
                <h6 class="mb-0">{{ item.account_name }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">Account Number:</label>
                <h6 class="mb-0">{{ item.account_number }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">Bank:</label>
                <h6 v-if="item.bank" class="mb-0">{{ item.bank.name }}</h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
        }
    }
}
</script>

<style>

</style>